import { render, staticRenderFns } from "./ManageVendorsPage.vue?vue&type=template&id=96109f6e&scoped=true&"
import script from "./ManageVendorsPage.vue?vue&type=script&lang=js&"
export * from "./ManageVendorsPage.vue?vue&type=script&lang=js&"
import style0 from "./ManageVendorsPage.vue?vue&type=style&index=0&id=96109f6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96109f6e",
  null
  
)

export default component.exports